import { BrowserRouter, Route, Switch } from "react-router-dom";
import Body from "./components/home/Home";
import LoginForm from "./components/login/LoginForm";
import ProductList from "./components/ProductList/ProductList";
import SingUpForm from "./components/singup/SingUpForm";
import Product from "./components/Product/Product";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./ScrollToTop";
import CartProvider from "./context/CartProvider";
import "react-toastify/dist/ReactToastify.css";
import CartPage from "./pages/cart/CartPage";
import AuthProvider from "./context/AuthProvider";
import { products } from "./Products";
import Footer from "./components/footer/Footer";
import "./app.style.css";
import { useState } from "react";
import i18next from "i18next";
console.log(products);
function App() {
  const [theme, setTheme] = useState("lightTheme");
  const changeTheme = (theme) => {
    setTheme(theme);
    if (theme === "lightTheme")
      return document.documentElement.classList.remove("dark");
    else return document.documentElement.classList.add("dark");
  };

  const changeLanguageHandler = () => {
    const language = i18next.language;
    if (language === "fa") {
      i18next.changeLanguage("en");
      document.documentElement.dir = "ltr";
    } else {
      i18next.changeLanguage("fa");
      document.documentElement.dir = "rtl";
    }
  };
  // const [products, setProducts] = useState([]);
  // useEffect(()=>{
  //   const getProduct =async()=>{
  //     try {
  //       const {data}= await http.get("/product");
  //       setProducts(data)
  //       console.log(products)
  //     } catch (error) {
  //      console.log(error)
  //     }

  //  }
  //   getProduct()},[])

  return (
    <div className="bg-lightscreen text-white dark:bg-Darkscreen ">
      <BrowserRouter>
        <ScrollToTop>
          <AuthProvider>
            <CartProvider>
              <ToastContainer theme="dark" />
              <Switch>
                <Route
                  path={"/kids/:id"}
                  component={() => (
                    <Product
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/love/:id"}
                  component={() => (
                    <Product
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/comdey/:id"}
                  component={() => (
                    <Product
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/classic/:id"}
                  component={() => (
                    <Product
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/cooking/:id"}
                  component={() => (
                    <Product
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />

                <Route
                  path={"/login"}
                  component={() => (
                    <LoginForm
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/singup"}
                  component={() => (
                    <SingUpForm
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/cart"}
                  component={() => (
                    <CartPage
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/"}
                  exact
                  component={() => (
                    <Body
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/kids"}
                  component={() => (
                    <ProductList
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/comedy"}
                  component={() => (
                    <ProductList
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/love"}
                  component={() => (
                    <ProductList
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/cooking"}
                  component={() => (
                    <ProductList
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
                <Route
                  path={"/classic"}
                  component={() => (
                    <ProductList
                      products={products}
                      setTheme={changeTheme}
                      theme={theme}
                      changeLanguage={changeLanguageHandler}
                    />
                  )}
                />
              </Switch>
              <Footer theme={theme} />
            </CartProvider>
          </AuthProvider>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
